// extracted by mini-css-extract-plugin
export default {"hobbies__grid":"AboutHobbies_hobbies__grid__jvFGW"};